(function ($) {

        //Listen for pagination clicks
        $(document).on('click', '.pagination .links a', function (e) {
            let newPage = $(this).attr('data-page');
            let oldPage = $('#paged').val();

            //Only change pages to a new page
            if (newPage != oldPage) {
                $('#paged').val(newPage);
                $('#filter-form').trigger('submit');
            }
        });
})(jQuery);
